define.alias("shared/components/shared/platform-notice", "calendar/components/shared/platform-notice");